/**
 * The spec the public site shows of a car is DERIVED on the server from the stock car (motor / gearbox text, LMS data): these helpers
 * only word it for the staff screens, so a missing value is visible and can be fixed where it comes from — the car's text in the stock.
 */

import type { FleetEntry } from './api';

type Spec = NonNullable<FleetEntry['vozidlo']>['spec'];

/** A fuel or powertrain the API gains without a label here is a compile error. */
export const POHON_NAZEV = {
  bev: 'Elektro (BEV)',
  phev: 'Plug-in hybrid (PHEV)',
  hev: 'Hybrid (HEV)',
  benzin: 'Benzín',
  nafta: 'Nafta',
} satisfies Record<NonNullable<Spec['pohon']>, string>;

export const PREVODOVKA_NAZEV = { manual: 'Manuální', automat: 'Automatická' } satisfies Record<NonNullable<Spec['prevodovka']>, string>;

/** `85 kW / 115 k`, or only the one stated; null when neither is. */
export function vykonText(spec: Pick<Spec, 'vykon_kw' | 'vykon_k'>): string | null {
  const dily = [spec.vykon_kw != null ? `${spec.vykon_kw} kW` : null, spec.vykon_k != null ? `${spec.vykon_k} k` : null].filter(Boolean);
  return dily.length ? dily.join(' / ') : null;
}

/** The facts the text states, in one line: `Benzín · 85 kW / 115 k · Manuální`; null when it states none. */
export function specShrnuti(spec: Spec | null | undefined): string | null {
  if (!spec) return null;
  const casti = [spec.pohon ? POHON_NAZEV[spec.pohon] : null, vykonText(spec), spec.prevodovka ? PREVODOVKA_NAZEV[spec.prevodovka] : null].filter(Boolean);
  return casti.length ? casti.join(' · ') : null;
}

/** What the car's text does not say (Czech nouns), so the staff know what to add to the car in the stock. */
export function specChybi(spec: Spec | null | undefined): string[] {
  if (!spec) return [];
  return [spec.pohon ? null : 'pohon', spec.vykon_kw != null || spec.vykon_k != null ? null : 'výkon', spec.prevodovka ? null : 'převodovku'].filter((x): x is string => x !== null);
}
